import { FC } from 'react';
import { Search } from 'ui/icons';
import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { useListContext } from './ListContext';

export const Header = styled.div`
  border-bottom: ${(props) => props.theme.spacing.values.single} solid
    ${(props) => props.theme.colors.neutrals.grey15};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: 'search actions';
  grid-area: header;
  padding: ${(props) => props.theme.spacing.values.base};
  width: 100%;
`;

export const SearchInput = styled(InputText)`
  grid-area: search;
`;

export const Actions = styled.div`
  margin-left: ${(props) => props.theme.spacing.values.base};
  grid-area: actions;
`;

type ListHeaderProps = {
  searchPlaceholder?: string;
};

export const ListHeader: FC<React.PropsWithChildren<ListHeaderProps>> = ({
  children,
  searchPlaceholder = 'Search items',
}) => {
  const { query, setQuery } = useListContext();
  return (
    <Header>
      <SearchInput
        placeholder={searchPlaceholder}
        value={query}
        Prefix={<Search />}
        onChange={setQuery}
      />
      {children && <Actions>{children}</Actions>}
    </Header>
  );
};
